<template>
  <div
    v-if="isBannerDisplay"
    class="cookie-banner"
  >
    <span class="cookie-banner-content">
      {{ $t("cookieBannerContent") }}
      <a
        href="https://www.istaging.com/legal/privacy_policy"
        target="_blank"
      >
        {{ $t("cookieBannerPolicyLinkText") }}
      </a>
      {{ $t("cookieBannerContentLinkAfter") }}
    </span>
    <button
      class="cookie-banner-btn"
      @click="acceptCookieHandler"
    >
      {{ $t("cookieBannerButtonText") }}
    </button>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { getDomain } from '../api/auth/index'
import { isIframe } from '@/api/utils'

const COOKIE_KEY = 'istaging_cookie'
export default {
  name: 'CookieBanner',
  data () {
    return {
      isAcceptCookie: false
    }
  },
  created () {
    try {
      this.isAcceptCookie = !!Cookies.get(COOKIE_KEY)
    } catch (error) {
      this.isAcceptCookie = false
    }
  },
  computed: {
    isBannerDisplay () {
      return !isIframe() && !this.isAcceptCookie
    }
  },
  methods: {
    acceptCookieHandler () {
      Cookies.set(COOKIE_KEY, 'all_agreed', { domain: getDomain(), expires: 365 })
      this.isAcceptCookie = true
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~css/common/main'

.cookie-banner{
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: #FFFFFF;
  padding: 20px 32px;
  z-index: 99;

  .cookie-banner-content{
    font-family: Noto Sans TC;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
    text-align: justify;
    text-shadow: none;
    color: #333;

    a{
      font-family: Noto Sans TC;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 24px;
      text-decoration-line: underline;
      text-shadow: none;
      color: #376FD5;
    }
  }

  .cookie-banner-btn{
    font-family: Noto Sans TC;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    text-shadow: none;
    text-wrap: nowrap;
    border-radius: 8px;
    padding: 8px 16px;
    margin-left: 64px;
    color: #FFF;
    background-color: #EC0974;

    @media (max-width: $response) {
      width: 100%;
      margin-top: 20px;
      margin-left: 0;
    }
  }

  @media (max-width: $response) {
    padding: 20px;
    flex-direction: column;
  }
}

</style>
